import SectionHeading from "./SectionHeading";
import { viewSteps } from "@/mocks/home";

export default function ViewingPath() {
  return (
    <section id="path" className="section-anchor bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="VIEWING PATH"
          title="四步找到适合你的观看入口"
          desc="不需要从头翻到尾。按下面的顺序，先锁定方向，再逐步缩小到具体条目与章节。"
          align="center"
        />

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-4 relative">
          {viewSteps.map((step, index) => (
            <div key={step.step} className="relative flex flex-col items-center text-center">
              {index < viewSteps.length - 1 && (
                <span className="hidden lg:block absolute top-8 left-[calc(50%+2.5rem)] w-[calc(100%-5rem)] h-px bg-background-300" />
              )}
              <span className="relative z-10 w-16 h-16 rounded-full flex items-center justify-center bg-primary-500 text-background-50 font-heading text-xl font-bold">
                {step.step}
              </span>
              <h3 className="mt-5 font-heading text-base md:text-lg font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2.5 text-sm leading-7 text-foreground-600 max-w-xs">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg bg-accent-500 p-6 md:p-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-5">
          <div className="max-w-2xl">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50">
              已经确定方向？直接跳到情境清单
            </h3>
            <p className="mt-2 text-sm md:text-base leading-7 text-background-50/85">
              十二条情境已按空间分类整理，支持关键词检索，可立即定位到与你关注点最接近的内容。
            </p>
          </div>
          <a
            href="#scenarios"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 font-label font-medium whitespace-nowrap hover:bg-background-100 transition-colors"
          >
            <i className="ri-filter-3-line" />
            打开情境筛选
          </a>
        </div>
      </div>
    </section>
  );
}